const SHOTS = [
  {
    src: "https://customer-assets.emergentagent.com/job_five-min-formula/artifacts/j2lk43hm_IMG_9615.PNG",
    alt: "WYNN splash screen",
    label: "The opening",
    accent: "rgba(255,170,210,0.4)",
    offset: "md:mt-0",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_five-min-formula/artifacts/29elgarj_IMG_9617.PNG",
    alt: "WYNN home with daily affirmation",
    label: "Daily affirmation",
    accent: "rgba(230,191,255,0.45)",
    offset: "md:mt-16",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_five-min-formula/artifacts/cijkhpkm_IMG_9616.PNG",
    alt: "WYNN explore library",
    label: "The library",
    accent: "rgba(168,230,255,0.4)",
    offset: "md:mt-4",
  },
];

function PhoneFrame({ src, alt, label, accent }) {
  return (
    <div className="flex flex-col items-center">
      <div className="relative">
        <div
          aria-hidden
          className="absolute -inset-6 blur-3xl opacity-50 -z-10 rounded-[60px]"
          style={{
            background: `radial-gradient(50% 50% at 50% 50%, ${accent} 0%, rgba(7,6,8,0) 70%)`,
          }}
        />
        <div className="relative w-[240px] md:w-[270px] aspect-[9/19.5] rounded-[44px] p-[10px] bg-[#0A0910] border border-[#F4F1EC]/15 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.7)]">
          <div className="absolute top-3 left-1/2 -translate-x-1/2 w-24 h-5 rounded-full bg-[#0A0910] border border-[#F4F1EC]/10 z-10" />
          <div className="relative w-full h-full rounded-[36px] overflow-hidden bg-white">
            <img
              src={src}
              alt={alt}
              className="w-full h-full object-cover object-top block"
              draggable="false"
            />
          </div>
        </div>
      </div>
      <div className="mt-6 text-[10px] uppercase tracking-[0.3em] text-[#F4F1EC]/55 font-body">
        {label}
      </div>
    </div>
  );
}

export default function PhoneGallery() {
  return (
    <section
      data-testid="wynn-preview"
      className="relative border-t border-[#F4F1EC]/10 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(7,6,8,1) 0%, rgba(15,12,20,1) 50%, rgba(7,6,8,1) 100%)",
        }}
      />
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8 items-end mb-16">
          <div className="col-span-12 md:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.32em] text-[#F4F1EC]/55 font-body">
              A look inside
            </div>
            <h2 className="mt-4 font-display tracking-tight leading-[1.02] text-[clamp(2rem,4.6vw,3.5rem)] font-medium text-[#F4F1EC]">
              Less screen.{" "}
              <span className="italic font-light text-aurora">More studio.</span>
            </h2>
            <p className="mt-5 font-body text-[#F4F1EC]/70 text-lg leading-[1.75] max-w-2xl">
              Three quiet doorways into the app: the gentle opening, the daily
              affirmation, and the library of practices waiting for you to choose
              what calls today.
            </p>
          </div>
        </div>

        <div
          data-testid="wynn-phone-gallery"
          className="grid grid-cols-1 md:grid-cols-3 gap-14 md:gap-8 justify-items-center items-start"
        >
          {SHOTS.map((s) => (
            <div key={s.label} className={s.offset}>
              <PhoneFrame {...s} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
